const attachment = {
  id: '544f947c-390b-4200-b599-d60b3a5bd46e',
  contentType: 'application/vnd.microsoft.card.adaptive',
  name: null,
  thumbnailUrl: null,
  contentUrl: null,
  content: JSON.stringify({
    type: 'AdaptiveCard',
    $schema: 'http://adaptivecards.io/schemas/adaptive-card.json',
    version: '1.4',
    body: [
      {
        type: 'ColumnSet',
        columns: [
          {
            type: 'Column',
            width: 1,
            items: [
              {
                type: 'TextBlock',
                text: 'Schedule LinkedIn Posts',
                wrap: true,
                fontType: 'Default',
                size: 'Large',
                weight: 'Bolder'
              },
              {
                type: 'TextBlock',
                text: '[[INPUT_SHARE_SCHEDULE_TEXT]]',
                wrap: true
              }
            ]
          }
        ]
      }
    ],
    actions: [
      {
        type: 'Action.OpenUrl',
        title: 'Schedule LinkedIn Posts',
        style: 'positive',
        url: '{{JOB_LINKEDIN_SCHEDULE_LINK}}'
      }
    ]
  })
};

export default {
  id: 'teams_schedule_jobs',
  title: 'Schedule jobs',
  type: 'Direct / Channel',
  canSendToChannel: true,
  relations: [ 'MANY_JOBS' ],
  description: 'Send a call to action button of up to 4 selected jobs to your employees so they can easily schedule to share them actross their network.',
  body: {
    attachments: [ attachment ],
    body: {
      contentType: 'html',
      content: `
      <div>
        <p>[[INPUT_INTRODUCTION_TEXT]]</p>
        <attachment id='${attachment.id}'></attachment>
      </div>`.split('\n').map(line => line.trim().replaceAll('\n', '')).join(''),
    },
  },
  inputs: {
    INPUT_INTRODUCTION_TEXT: {
      label: 'Intro',
      placeholder: 'Schedule some jobs today! ...',
      defaultValue: 'Schedule some jobs today!',
      type: 'HTML'
    },
    INPUT_SHARE_SCHEDULE_TEXT: {
      label: 'Schedule',
      placeholder: 'Schedule your posts to go out at the best times for your network ...',
      defaultValue: 'Schedule your posts to go out at the best times for your network and win some awesome rewards.',
      type: 'TEXTAREA'
    }
  }
};


// WEBPACK FOOTER //
// ./src/views/campaign-admin/templates/teams/scheduleJobs.js